// Fișierul facets.js poate rămâne gol sau poate conține doar funcționalitățile esențiale
// Deoarece folosim redirect direct, nu mai avem nevoie de logica complexă



(function() {
  'use strict';
  
  // Păstrăm doar funcționalitățile esențiale pentru compatibilitate
  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('input').forEach((element) => {
        element.addEventListener('change', this.onRangeChange.bind(this));
      });
      this.setMinAndMaxValues();
    }

    onRangeChange(event) {
      this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
      const inputs = this.querySelectorAll('input');
      const minInput = inputs[0];
      const maxInput = inputs[1];
      
      if (maxInput.value) {
        minInput.setAttribute('max', maxInput.value);
      }
      if (minInput.value) {
        maxInput.setAttribute('min', minInput.value);
      }
    }
  }

  customElements.define('price-range', PriceRange);

  // Păstrăm și FacetRemove pentru funcționalitatea de ștergere filtre
  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      const facetLink = this.querySelector('a');
      if (facetLink) {
        facetLink.addEventListener('click', this.closeFilter.bind(this));
      }
    }

    closeFilter(event) {
      // Acest eveniment este gestionat de către sistemul Shopify
      // Păstrăm pentru compatibilitate
    }
  }

  customElements.define('facet-remove', FacetRemove);
})();